import React from 'react';

import { OneColumn } from 'components/page';
import { BandaPrecoGrid } from 'pages/complementar/banda-preco/components';

export function BandaPrecoListComp() {
    return (
        <OneColumn title="Bandas de Preços" createButton>
            <BandaPrecoGrid />
        </OneColumn>
    );
}
